import { Form, Input, Image, Button } from 'antd';
// import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import React, { useState, useEffect } from 'react';
import logo from '../../assets/images/logo_coopharma.png';
import { sendData } from '../../httpRequests';
import './auth.css';



const Login = () => {
	
	// useEffect(() => {
	// 	console.log("login 2")
	// }, [])
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	

	const login = (values) => {
		setIsLoading(true);

		const url = '/auth/loginPanel';
		sendData(url, values).then((response) => {
			console.log(response)
			// setTimeout(() => {
				setIsLoading(false);
				if (Object.keys(response).length > 0) {
					const pharmacy = response['pharmacy'];
					localStorage.setItem('PHARMACY_LOGGED', pharmacy.id);
					localStorage.setItem('token', response.token);
					localStorage.setItem('Role_id', pharmacy.role_id);
					if (pharmacy.role_id == 2) navigate('/orders', { replace: true });
					else navigate('/admin/orders', { replace: true });
				} else {
					Swal.fire({
						text: 'Wrong credentials',
						icon: 'warning',
						confirmButtonColor: '#128780'
					});
				}
			// }, 1500);
		});
	};

	return (
		<div className='container'>
			<div className='auth-header'>
				<Image src={logo} className='logo' preview={false} height={100} width={280} />
				<h1 className='title'>Login</h1>
			</div>
			<Form layout='vertical' className='form' onFinish={login}>
				<Form.Item
					label='Email'
					name='email'
					rules={[
						{
							required: true
						}
					]}
				>
					
					<Input size='large' type='email' autoFocus={true} autoCapitalize='false' />
				</Form.Item>
				<Form.Item
					label='Password'
					name='password'
					rules={[
						{
							required: true
						}
					]}
				>
					<Input.Password size='large' />
				</Form.Item>
				{/* <div className='forgotPassword'>
					<span>Forgot your password?</span>
				</div> */}
				<div className='formFooter'>
					<Button type='primary' htmlType='submit' loading={isLoading} disabled={isLoading}>
						Sign In
					</Button>
					{/* <span className='spanText'>
						Don&apos;t have an account?{' '}
						<span
							className='spanTextLink'
							onClick={() => {
								window.location.href = '/register';
							}}
						>
							Sign up!
						</span>
					</span> */}
				</div>
			</Form>
		</div>
	);
};

export default Login;
